<template>
  <main class="body">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Raleway:wght@400;700&display=swap" rel="stylesheet">
    <Header />
    <Hero />
    <How />
    <Early />
    <Footer />
  </main>
</template>

<script>
import Header from '../components/fylo-two-column-landing/Header.vue';
import Hero from '../components/fylo-two-column-landing/Hero.vue';
import How from '../components/fylo-two-column-landing/How.vue';
import Early from '../components/fylo-two-column-landing/Early.vue';
import Footer from '../components/fylo-two-column-landing/Footer.vue';

export default {
  name: 'FyloTwoColumnLanding',
  components: {
    Header,
    Hero,
    How,
    Early,
    Footer,
  },
};

</script>

<syyle src="../css/fylo-two-column/global.css" scoped />
<style lang="scss" scoped>

.body {
  --very-dark-blue: hsl(243, 87%, 12%);
  --desaturated-blue: hsl(238, 22%, 44%);
  --bright-blue: hsl(224, 93%, 58%);
  --moderate-cyan: hsl(170, 45%, 43%);
  --light-grayish-blue: hsl(240, 75%, 98%);
  --light-gray: hsl(0, 0%, 75%);
  --white: hsl(0, 0%, 100%);

  --border-radius: 0.3rem;

  /* spacing */
  --sm-spacer: 2rem;
  --bg-spacer: 4rem;

  /* fonts */
  --fs-h0: 5rem;
  --fs-h1: 2.5rem;
  --fs-h2: 1.5rem;
  --fs-h3: 1rem;
  --fs-h4: 1rem;
  --fs-base: 0.625rem;
  --fw-100: 100;
  --fw-normal: 400;
  --fw-600: 600;
  --fw-700: 700;
  --fw-900: 900;

  --ff-default: 'Open Sans', sans-serif;
  --ff-alt: 'Raleway';
  --ff-awesome: FontAwesome;

  font-family: var(--ff-default);
  font-size: var(--fs-h3);
  text-align: center;
  padding-top: var(--sm-spacer);

  @media (min-width: 30em) {
    --fs-h0: 6rem;
    --fs-h1: 3rem;
    --fs-h2: 2rem;
    --fs-h3: 1.3rem;
    --fs-h4: 1rem;
    --fs-base: 0.9375rem;

    --sm-spacer: 3rem;
    --bg-spacer: 6rem;
  }
}
</style>
